export default __webpack_public_path__ + "static/media/e1a.98dda3eb.png";